import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Home from './components/Home';

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <div className="min-h-screen flex flex-col relative overflow-x-hidden bg-[#f7f8fb] text-[#18181f]">
        <div className="site-surface" aria-hidden="true" />
        <Header />
        <main className="flex-grow relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </MotionConfig>
  );
}

export default App;
